import { createFederationRef } from "@constructor/federation-common/base";
function createFederationFeatureFlags() {
  const featureFlags = createFederationRef([]);
  const fragmentApi = {
    isFeatureEnabled,
    onFeatureEnabledChange,
    getFeatureFlag,
    onFeatureFlagChange
  };
  return {
    onFeatureEnabledChange,
    onFeatureFlagChange,
    isFeatureEnabled,
    setFeatureFlags,
    setFeatureFlag,
    hasFeatureFlag,
    getFeatureFlag,
    fragmentApi
  };
  function onFeatureEnabledChange(featureName, fn) {
    return featureFlags.subscribe((value, oldValue) => {
      const newEnabled = value.includes(featureName);
      const oldEnabled = oldValue.includes(featureName);
      if (newEnabled !== oldEnabled) {
        fn(newEnabled, oldEnabled);
      }
    });
  }
  function onFeatureFlagChange(featureName, fn) {
    return featureFlags.subscribe((value, oldValue) => {
      const oldFlag = resolveFeatureFlag(featureName, oldValue);
      const newFlag = resolveFeatureFlag(featureName, value);
      if ((oldFlag == null ? void 0 : oldFlag.value) !== (newFlag == null ? void 0 : newFlag.value)) {
        fn((newFlag == null ? void 0 : newFlag.value) ?? null, (oldFlag == null ? void 0 : oldFlag.value) ?? null);
      }
    });
  }
  function setFeatureFlags(newFeatureFlags) {
    featureFlags.set(newFeatureFlags);
  }
  function setFeatureFlag(newFeatureFlag) {
    featureFlags.set(Array.from(/* @__PURE__ */ new Set([...featureFlags.get(), newFeatureFlag])));
  }
  function getFeatureFlag(name) {
    return resolveFeatureFlag(name);
  }
  function hasFeatureFlag(name) {
    var _a;
    return !!((_a = resolveFeatureFlag(name)) == null ? void 0 : _a.value);
  }
  function resolveFeatureFlag(name, flags = featureFlags.get()) {
    const value = flags.includes(name);
    if (!import.meta.env.DEV) {
      return { value };
    }
    return value ? { value } : null;
  }
  function isFeatureEnabled(featureName) {
    return featureFlags.get().includes(featureName);
  }
}
export {
  createFederationFeatureFlags as c
};
//# sourceMappingURL=featureFlags.js.map
